import { type FC } from "react";

interface ChatMessageListJoinedEventItemProps {
  message: string;
}

const ChatMessageListJoinedEventItem: FC<ChatMessageListJoinedEventItemProps> = ({ message }) => {
  return (
    <div className="flex justify-start">
      <div className="py-2 px-4 rounded-full bg-lastbot-surface-muted leading-[1.6] text-sm text-lastbot-on-surface-soft font-medium" data-testid={`joined-event-message`}>
        {message}
      </div>
    </div>
  );
};

export default ChatMessageListJoinedEventItem;
